import api from '@/api'
const state = {

}

const mapStorageStatistics = data => {
  const statistics = {input: [], output: []}
  Object.keys(data || {}).forEach(key => {
    const items = Array.isArray(data[key]) ? data[key] : []
    if (key.toLowerCase().includes('input')) statistics.input.push(...items)
    if (key.toLowerCase().includes('output')) statistics.output.push(...items)
  })
  return statistics
}

const mapRentalUserStatistics = data => ({
  userTotal: data ? data.totalCount || 0 : 0,
  userNames: data ? data.dimensionValues || [] : [],
  users: (data ? data.rows || [] : []).map(row => ({
    hardwareModel: row.hardwareMode,
    values: Object.keys(row.dimensionCountMap || {}).map(name => ({
      name,
      count: row.dimensionCountMap[name],
    })),
  })),
})

const actions = {
  async getNewAdminBulletin ({state}, payload) {
    const {data, result, code} = await api.homeApi.getNewAdminBulletin(payload)
    return {data, result, code}
  },
  async queryRenderingTaskOfPlatformStat (_, payload = {}) {
    const {data, result, code} = await api.homeApi.queryRenderingTaskOfPlatformStat(payload)
    return {data, result, code}
  },
  async queryNodeStatistics (_, payload = {}) {
    const {data, result, code} = await api.homeApi.queryNodeStatistics(payload)
    return {data, result, code}
  },
  async queryTaskFrameGroupStat () {
    const {data, result, code} = await api.homeApi.queryTaskFrameGroupStat()
    return {data: Array.isArray(data) ? data : [], result, code}
  },
  async getNodeCategoryStatusStatistics () {
    const {data, result, code} = await api.homeApi.getNodeCategoryStatusStatistics()
    return {
      data: {
        categories: data && Array.isArray(data.categories) ? data.categories : [],
        statuses: data && Array.isArray(data.statuses) ? data.statuses : [],
      },
      result,
      code,
    }
  },
  async queryStorageStat (_, payload = {}) {
    const {data, result, code} = await api.homeApi.queryStorageStat(payload)
    return {
      data: mapStorageStatistics(data),
      result,
      code,
    }
  },
  async getRentalUserStatistics (_, payload = {}) {
    const {data, result, code} = await api.homeApi.getRentalUserStatistics({
      ...payload,
      dimension: 'leaseUserName',
    })
    return {
      data: mapRentalUserStatistics(data),
      result,
      code,
    }
  },
  async queryNodeCountByCategory ({state}, payload) {
    const {data, result, code} = await api.homeApi.queryNodeCountByCategory(payload)
    return {data, result, code}
  },
  async getStorageStatByIP ({state}, payload) {
    const {data, result, code} = await api.homeApi.getStorageStatByIP(payload)
    return {data, result, code}
  },
}

const mutations = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
